import {
  CustomTransactionItemValue,
  TransactionProperty,
} from '@/features/InvoiceReport/Edit/type';
import {
  DATE_FORMAT_HYPHEN_YEAR_MONTH,
  DATE_MONTH_FORMAT,
  stringToDayjs,
  toISODateString,
  toISODateStringYearMonth,
} from 'date-util';
import { Dayjs, isDayjs } from 'dayjs';

/**
 * Maps API `custom_transaction_items` (string keys and values) to form values.
 * Date-type custom fields are converted from strings to Dayjs because DateTypeCell expects Dayjs.
 */
export const mapApiCustomTransactionItemsToFormValues = (
  raw: Record<string, string> | undefined | null,
  transactionProperties: TransactionProperty[] | undefined
): Record<string, CustomTransactionItemValue> | undefined => {
  if (!raw || Object.keys(raw).length === 0) return undefined;

  const transactionItems: Record<string, CustomTransactionItemValue> = {};

  Object.entries(raw).forEach(([key, value]) => {
    const transactionProperty = transactionProperties?.find(
      (property) => property.id === key
    );
    if (
      transactionProperty &&
      typeof value === 'string' &&
      transactionProperty.componentType === 'date'
    ) {
      transactionItems[key] =
        transactionProperty.dateFormatType === 'year_month'
          ? stringToDayjs(value, [
              DATE_MONTH_FORMAT,
              DATE_FORMAT_HYPHEN_YEAR_MONTH,
            ])
          : stringToDayjs(value);
    } else {
      transactionItems[key] = value;
    }
  });

  return transactionItems;
};

export const formatPulldownOptionForExport = (
  label?: CustomTransactionItemValue,
  code?: string
) => {
  return label === undefined
    ? ''
    : String(label).concat(code ? `(${code})` : '') ?? '';
};

export const formatDateForExport = (
  unformatted?: string | number | boolean | Dayjs | null | undefined,
  dateFormatType?: string
) => {
  if (isDayjs(unformatted) && dateFormatType === 'year_month') {
    return toISODateStringYearMonth(unformatted) || '';
  } else if (isDayjs(unformatted)) {
    return toISODateString(unformatted) || '';
  }

  return String(unformatted || '');
};
